// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"CarModelCarousel_swiper-slide-active__RaFm9","wrapper":"CarModelCarousel_wrapper__QPiqQ"};